import { GenericComponent } from '@/components/GenericComponent';
import * as styles from '@/styles/ContentBox';
import { PropsFromComponent } from '@/types/component';

export type BoxProps = PropsFromComponent<typeof Box>;

export const Box = GenericComponent({ styles });
